import { inject } from "@angular/core";
import {
  CanActivateFn,
  Router,
  UrlTree,
} from "@angular/router";

import { GenericErrorHandler } from "../../services/error-handlers.service";
import { ErrorPageCode } from "../../app.enums";

import { ActivityIndicatorService, AuviousRtcService } from "../../../core-ui";

export const rtcRegistrationGuard: CanActivateFn = async (
  route,
  state
): Promise<boolean | UrlTree> => {
  const rtcService = inject(AuviousRtcService);
  const errorHandler = inject(GenericErrorHandler);
  const activityService = inject(ActivityIndicatorService);
  const router = inject(Router);

  if (rtcService.registered()) {
    return true;
  }
  try {
    activityService.loading(true);
    await rtcService.register();
    return true;
  } catch (error) {
    errorHandler.handleError(error);
    return router.createUrlTree(
      ["/error", ErrorPageCode.RTC_CONNECTION_FAILURE],
      { queryParamsHandling: "preserve" }
    );
  } finally {
    activityService.loading(false);
  }
};
